export const LOGIN_ROOT = '/login'
export const APP_LAUNCHER = '/oauth/launch/:clientId'
export const CONSENT = '/oauth/consent'

export const PASSWORD_RESET = '/users/password/recover'
export const PASSWORD_RESET_CONFIRMATION = '/users/password/recover/:token'
export const ACCEPT_INVITATION = '/users/invitation/accept'

// Enforced MFA setup (AUTHN-3512): no Workspace/Bearer session yet at this
// point, so it lives here rather than login-settings — see AUTHN-3787.
export const SETUP_MFA_ENFORCED = '/users/settings/mfa'
export const SETUP_MFA = '/users/settings/mfa/setup'
export const SETUP_TOTP = '/users/settings/mfa/setup/totp'
export const SETUP_WEB_AUTHN = '/users/settings/mfa/setup/webauthn'
